import { render, staticRenderFns } from "./titre-block.vue?vue&type=template&id=2b929c28&"
import script from "./titre-block.vue?vue&type=script&lang=js&"
export * from "./titre-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports